//TODO DPH: Phase out and replace with moment.js
var DateTime = (function () {
    var getCurrentDate = function () {
        return new Date($.now());
    };

    var toString = function (date) {
        return date.toLocaleDateString() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + '.' + date.getMilliseconds();
    };

    var isValidDate = function (s) {
        if (s == undefined) return false;
        if (s === +s) s = s.toString();
        var matches = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
        if (matches === null) {
            return false;
        } else {
            var year = parseInt(matches[3], 10);
            var month = parseInt(matches[2], 10) - 1; // months are 0-11
            var day = parseInt(matches[1], 10);
            var date = new Date(year, month, day);
            if (date.getFullYear() !== year
                || date.getMonth() != month
                || date.getDate() !== day
            ) {
                return false;
            } else {
                return true;
            }
        }
    };

    var isValidDateTime = function (s) {
        if (s == undefined) return false;
        if (s === +s) s = s.toString();
        var matches = s.match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
        if (matches === null) {
            return false;
        } else {
            var year = parseInt(matches[3], 10);
            var month = parseInt(matches[2], 10) - 1; // months are 0-11
            var day = parseInt(matches[1], 10);
            var hour = parseInt(matches[4], 10);
            var minute = parseInt(matches[5], 10);
            var second = parseInt(matches[6], 10);
            var date = new Date(year, month, day, hour, minute, second);
            if (date.getFullYear() !== year
                || date.getMonth() != month
                || date.getDate() !== day
                || date.getHours() !== hour
                || date.getMinutes() !== minute
                || date.getSeconds() !== second
            ) {
                return false;
            } else {
                return true;
            }
        }
    };

    var parseDate = function (s) {
        if (s === +s) s = s.toString();

        var deRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/; //DE u.a.
        var enRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/; //EN u.a.
        var daRegex = /^(\d{2})\-(\d{2})\-(\d{4})$/; //DA u.a.
        var matches = s.match(enRegex) || s.match(deRegex) || s.match(daRegex);

        if (matches === null) {
            return null;
        } else {
            var year = parseInt(matches[3], 10);
            var month = parseInt(matches[2], 10) - 1; // months are 0-11
            var day = parseInt(matches[1], 10);
            var date = new Date(year, month, day);
            if (date.getFullYear() !== year
                || date.getMonth() != month
                || date.getDate() !== day
            ) {
                return null;
            } else {
                return date;
            }
        }
    }

    var parseDateTime = function (s) {
        if (s === +s) s = s.toString();
        var matches = s.match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
        if (matches === null) {
            return null;
        } else {
            var year = parseInt(matches[3], 10);
            var month = parseInt(matches[2], 10) - 1; // months are 0-11
            var day = parseInt(matches[1], 10);
            var hour = parseInt(matches[4], 10);
            var minute = parseInt(matches[5], 10);
            var second = parseInt(matches[6], 10);
            var date = new Date(year, month, day, hour, minute, second);
            if (date.getFullYear() !== year
                || date.getMonth() != month
                || date.getDate() !== day
                || date.getHours() !== hour
                || date.getMinutes() !== minute
                || date.getSeconds() !== second
            ) {
                return null;
            } else {
                return date;
            }
        }
    }

    var toTimeStamp = function (d) {
        var array = [];
        if (Object.prototype.toString.call(d) !== '[object Date]') return '';
        array.push(
            d.getFullYear(),
            getMonth(d),
            getDay(d),
            getHours(d),
            getMinutes(d),
            getSeconds(d)
        );

        return array.join('');
    }

    function getMonth(date) {
        return ('0' + (date.getMonth() + 1)).slice(-2);
    }

    function getDay(date) {
        return ('0' + date.getDate()).slice(-2);
    }

    function getHours(date) {
        return ('0' + date.getHours()).slice(-2);
    }

    function getMinutes(date) {
        return ('0' + date.getMinutes()).slice(-2);
    }

    function getSeconds(date) {
        return ('0' + date.getSeconds()).slice(-2);
    }

    function isPastDate(date) {
        var currentDate = this.getCurrentDate();

        date.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0)

        var isInThePast = date < currentDate;

        if (isInThePast == true) {
            return true;
        }

        //return nothing otherwise!
    }

    var fromUnix = function (unixTimeStamp) {
        var parsed = new Date(parseInt(unixTimeStamp.substr(6)));
        return getDay(parsed) + '.' + getMonth(parsed) + '.' + parsed.getFullYear();
    }

    return {
        //fromUnix: fromUnix,
        getCurrentDate: getCurrentDate,
        toString: toString,
        isValidDate: isValidDate,
        isValidDateTime: isValidDateTime,
        parseDate: parseDate,
        parseDateTime: parseDateTime,
        toTimeStamp: toTimeStamp,
        isPastDate: isPastDate,
    };
})();

//yay pollution
globalThis.DateTime = DateTime;